// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__T2AFh","wrapper__message":"EmptyState_wrapper__message__-szbr","wrapper__title":"EmptyState_wrapper__title__8PBN3"};